import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="py-24 px-4 pb-32 bg-[#FFF5F7]" data-id="element-29">
      <div className="max-w-4xl mx-auto" data-id="element-30">
        <FadeIn data-id="element-31">
          <div className="text-center mb-16" data-id="element-32">
            <p className="text-lg text-[#7a5568] mb-4" data-id="element-33">
              Esto nació de escuchar la misma frase una y otra vez
            </p>
            <h3 className="text-3xl md:text-5xl font-serif text-[#4a2535] italic mb-12" data-id="element-34">
              "Siento que hago todo… y aun así no alcanza."
            </h3>
            <p className="text-xl text-[#c4607a]" data-id="element-35">
              No era falta de amor. Era falta de herramientas reales.
            </p>
          </div>
        </FadeIn>

        <div className="bg-white p-8 md:p-12 rounded-3xl border border-[#f0d0dc] mb-16 shadow-[0_12px_40px_rgba(196,96,122,0.08)]" data-id="element-36">
          <FadeIn data-id="element-37">
            <h4 className="text-2xl font-serif text-[#2d1520] mb-8 text-center" data-id="element-38">
              Si hoy sentís que:
            </h4>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-39">
              {['Hablás y no te escucha', 'Siempre discuten por lo mismo', 'Te cansaste de ser la que intenta', 'Tenés miedo del desgaste silencioso'].map((item, i) => <div key={i} className="flex items-center gap-4" data-id="element-40">
                  <div className="bg-[#c4607a]/10 p-2 rounded-full" data-id="element-41">
                    <Check className="w-5 h-5 text-[#c4607a]" data-id="element-42" />
                  </div>
                  <span className="text-lg text-[#7a5568]" data-id="element-43">{item}</span>
                </div>)}
            </div>
            <div className="mt-12 text-center" data-id="element-44">
              <p className="text-3xl font-script text-[#c4607a]" data-id="element-45">
                Esto es para vos.
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn data-id="element-46">
          <div className="text-center space-y-8" data-id="element-47">
            <p className="text-xl md:text-2xl text-[#4a2535] font-light" data-id="element-48">
              Antes de rendirte. Antes de apagarte. Antes de resignarte.
            </p>
            <p className="text-2xl md:text-3xl font-serif text-[#2d1520] font-bold" data-id="element-49">
              Leé esto.
            </p>

            <div id="precio" className="py-8" data-id="element-50">
              <p className="text-2xl md:text-4xl font-serif text-[#c4607a] mb-8" data-id="element-51">
                👉 Porque no estás fallando. Lo estás haciendo bien.
              </p>

              <div className="mb-8" data-id="element-52">
                <p className="text-lg text-[#7a5568] mb-2" data-id="element-53">
                  Precio especial de lanzamiento
                </p>
                <div className="flex items-center justify-center gap-3" data-id="element-54">
                  <span className="text-2xl text-[#7a5568]/50 line-through decoration-[#c4607a]/40" data-id="element-55">
                    $19.800
                  </span>
                  <span className="text-5xl md:text-6xl font-serif font-bold text-[#c4607a]" data-id="element-56">
                    $9.900
                  </span>
                </div>
                <p className="text-sm text-[#7a5568] mt-2" data-id="element-57">
                  Acceso inmediato · Descarga digital
                </p>
              </div>

              <a href="https://www.reconectarhoy.com/cart/47802677297387:1" target="_blank" rel="noopener noreferrer" className="group bg-[#c4607a] hover:bg-[#b35068] text-white px-10 py-5 rounded-full text-xl font-semibold transition-all duration-300 transform hover:scale-105 shadow-[0_4px_24px_rgba(196,96,122,0.25)] hover:shadow-[0_8px_40px_rgba(196,96,122,0.4)] flex items-center gap-3 mx-auto no-underline" data-id="element-58">
                Quiero empezar a conectar
                <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-59" />
              </a>
            </div>

            <motion.div className="mt-12 flex justify-center" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.5,
            duration: 1
          }} data-id="element-60">
              <img src="https://cdn.magicpatterns.com/uploads/23xQnoLCh3GWCv8zaG2H5B/LO_ESTAS_HACIENDO_BIEN_1X1_IMAGEN.png" alt="Lo Estás Haciendo Bien" className="w-32 h-32 rounded-lg shadow-[0_8px_24px_rgba(196,96,122,0.15)] opacity-90 hover:opacity-100 transition-opacity duration-500" data-id="element-61" />
            </motion.div>
          </div>
        </FadeIn>
      </div>
    </section>;
}